import { decorate, observable, action, computed } from 'mobx';
import BaseStore from '../../BaseStore';
import Util from 'utils/Utils';
// import { dayFieldSorter, quarterYearFieldSorter } from './components/DateOptions';

class RemindersStore extends BaseStore {
    isLoading = false

    reminders = []
    recipients = []
    sheetUsers = []
    sheetRoles = []
    savingReminders = new Set();
    isReminderSavedTextShown = false;

    constructor(appStore, containerStore, isScheduled = true) {
        super(appStore);
        this.containerStore = containerStore;
        this.isScheduled = isScheduled;
    }

    get list() {
        return {
            id: this.containerStore.listConfig.list.id,
            name: this.containerStore.listConfig.list.name,
            columns: this.containerStore.listConfig.listData,
        };
    }

    get listColumns() {
        return this.list.columns;
    }

    get listId() {
        return this.list.id;
    }

    get dateColumns() {
        const me = this;

        return me.list.columns.filter(col => (col.column_type_id == 4 || col.column_type_id == 16) )
    }

    onRemindersChange() {
        const me = this;
        const hasReminder = this.reminders.find(reminder => reminder.id);

        // setTimeout(() => {
        me.listeners?.onRemindersChange(!!hasReminder);
        // }, 2000)
        // return !!hasReminder;
    }

    getDefaultRemindersData = () => {
        return [this.getDefaultReminderData()]
    }

    getDefaultReminderData = () => {
        const me = this;
        const config = this.appStore.configStore.config;

        return {
            criteria: "",
            data: {
                additional_emails: [],
                criteria: "",
                // id: "1",
                list_id: me.listId,
                mail_account_id: "0",
                // mail_attachment: "{"type":"template","content":"","file_type":"pdf"}",
                // mail_body: 'Here are the row details -↵<table class="row - view - table">↵	<tbody>↵		<tr class="view - row - table - tr" style="margin - top: 18px; ">↵			<td style="vertical - align: top; width: 33 % ">text</td>↵			<td style="vertical- align: top; width: 77 % "><%=Untitled.text%></td>↵		</tr>↵		<tr class="view - row - table - tr" style="margin - top: 18px; ">↵			<td style="vertical - align: top; width: 33 % ">Time col</td>↵			<td style="vertical - align: top; width: 77 % "><%=Untitled.timeCol%></td>↵		</tr>↵	</tbody>↵</table>↵<br />↵Please login below to check the details.<br />↵<a href=" <%=LIST_URL %> ">Untitled</a><br />↵<br />↵Regards,<br />↵Tigersheet.com',
                mail_body: me.getMailBodyTemplate(),
                mail_subject: `Reminder From ${config.site.title}`,
                mode: "4",
                recipients: me.getDefaultRolesForReminder(),
            },
            event: this.isScheduled ? "scheduled" : "",
            event_data: {
                // id: "1", 
                // handler_id: "4", 
                count: 1,
                count_type: "0",
                is_list_specific: "0",
                schedule_type: "1",
                scheduled_time: "",
            },
            // id: "4",
            is_list_specific: "0",
            is_new_row_skipped: "0",
            is_system: "0",
            is_paused: "0",
            list_id: me.listId,
            name: this.isScheduled ? `Reminder From ${config.site.title}` : `Notification From ${config.site.title}`,
            type: "notification",
            // updated_at: "2020-05-20 15:31:00",
        }
    }

    addNewReminder = () => {
        const me = this;

        me.reminders = [...me.reminders, this.getDefaultReminderData()]
    }

    deleteReminder = async (key) => {
        const me = this;
        const reminder = me.reminders[key];
        try {
            await this.appStore.notificationStore.confirm({
                description: (
                    "This action will permanently delete this reminder"
                ),
            });
        } catch (e) {
            return;
        }
        me.savingReminders.add(reminder.id)
        window.TL.ApiClient.EventHandlers.deleteHandler({
            handler_id: reminder.id,
        }).then({
            success: (response) => {
                if (!response.success) {
                    console.log(response);
                }
                me.savingReminders.delete(reminder.id)

                me.reminders.splice(key, 1);
                me.reminders = [...me.reminders];
                me.onRemindersChange()
                // if (!reminder.id) {
                // reminder.id = response.data
                // }
                // console.log(response);
                // this.getEmailColumns(response.data)
            }
        })
    }

    get sheetColumnsFormatted() {
        const me = this,
            rows = [];

        // if (true || this.includeColumnRecipients) {
        var list = this.getSheet(),
            columns = this.formatListColumns(Ext.clone(list.columns), list.name);

        if (this.list.has_parent) {
            columns = columns.concat(TL.list.settings.lookup.CriteriaHelper.formatCurrentSubSheetRowColumns(Ext.clone(this.list), {
                aliasKey: "alias_name",
                parentListNameSuffix: ""
            }));
        }

        for (var i = 0; i < columns.length; i++) {
            var allowedColumnTypes = [3, 10, 11, 13, 14], //1, 3, 8, 11, 13,
                columnType = parseInt(columns[i]["column_type_id"]),
                doAdd = true;
            if (true || allowedColumnTypes.indexOf(columnType) > -1 ) {
                /*if (false && columnType != 14) {
                 var options = Ext.decode(columns[i]["options"]);
                 options = options[0];
                 if (options.column_type && options.column_type == "email") {
                 doAdd = true;
                 }
                 } else {
                 doAdd = true;
                 }*/

                if (doAdd) {
                    columns[i]["id"] = /*"column_" +*/ columns[i]["id"];
                    columns[i]["type"] = "column";
                    rows.push(columns[i]);
                }
            }
        }
        // }

        return rows;
        // console.log(rows);
        // me.recipients = rows;
    }

    get isAddNewReminderShown() {
        const me = this;
        const isNewReminder = me.reminders.find(reminder => !reminder.id)

        return !isNewReminder && (!me.isScheduled || me.dateColumns.length > 0);
    }

    getSheet = () => {
        var me = this,
            hasParent = me.list.has_parent && me.list.parent_list;

        return hasParent ? me.list.parent_list : me.list;
    }

    formatListColumns = (listColumns, listNameStr) => {
        let formattedColumns = TL.list.settings.lookup.CriteriaHelper.formatListColumns(listColumns, listNameStr);
        let existingIdColumn = formattedColumns.findIndex(col => col.name.toLowerCase() === 'id' && col.id === this.listId + "_id");
        console.log("existingIdColumn", existingIdColumn);
        if(existingIdColumn == -1) {
            let idColumn = {
                "id": this.listId + "_id",
                "list_id": this.listId,
                "column_type_id": "5",
                "name": "ID",
                "group_id": "0",
                "options": "[{\"decimals\":0}]",
                "alias_name": Util.toUpperCamelCase(this.list.name) +".id",
                "formula_id": "0",
                "event_handlers": "{\"system\":[],\"user\":[]}",
                "dafault_type": "1",
                "group": null,
                "group_order": null,
                "formula": null,
                "referred_column_ids": null,
                "col_width": "180",
                "list_name": this.list.name,
                "alias_path": Util.toUpperCamelCase(this.list.name) +".id",
                "unique_id": this.listId + "_id-1",
                "type" : "column",
            };
            formattedColumns.unshift(idColumn);
        }
        return formattedColumns;
    }

    setSheetRoles = (roles) => {
        const me = this;

        var rows = [
            { "id": "role_0", "alias_name": "role_0", "name": "To all shared users", list_name: "Users", type: "role" }
        ];

        for (var i = 0; i < roles.length; i++) {
            rows.push({
                "id": "role_" + roles[i]["id"],
                "alias_name": "role_" + roles[i]["id"],
                "name": roles[i]["name"],
                list_name: "Users",
                "is_admin": roles[i].is_admin,
                "type": "role"
            });
        }

        me.sheetRoles = rows;
        const unsavedReminder = this.reminders.find(reminder => !reminder.id);
        if (unsavedReminder) {
            unsavedReminder.data.recipients = me.getDefaultRolesForReminder();
        }
    }

    get sheetUsersFormatted() {
        const me = this;
        const rows = [];

        for (var i = 0; i < me.sheetUsers.length; i++) {
            rows.push({
                "id": me.sheetUsers[i]["email"],
                "alias_name": me.sheetUsers[i]["email"],
                "name": me.sheetUsers[i]["email"],
                list_name: "Users",
                "type": "email"
            });
        }

        return rows;
    }

    getRoles = () => {
        const me = this;

        window.TL.ApiClient.ListRoles.getRoles({
            list_id: me.listId
        }).then({
            success: (response) => {
                if (!response.success) {
                    console.log(response);
                }
                // me.sheetRoles = response.data;
                this.setSheetRoles(response.data)
            }
        })

        window.TL.ApiClient.ListRoles.getSharedUsers({
            list_id: me.listId
        }).then({
            success: (response) => {
                if (!response.success) {
                    console.log(response);
                }
                me.sheetUsers = response.data;
                // this.getEmailColumns(response.data)
            }
        })
    }

    getDefaultRolesForReminder = () => {
        const me = this;
        const roles = [];

        const adminRole = me.sheetRoles.find(role => role.is_admin)
        if (adminRole) {
            roles.push(adminRole.alias_name);
        }

        return roles;
    }

    handleClick = event => {
        this.reminders = [];
        this.fetchData();
        this.getRoles();
        this.anchorEl = event.currentTarget;
    };

    handleClose = () => {
        this.anchorEl = null;
    };

    fetchData() {
        let me = this,
            response;


        if (me.currentAjaxRequest) {
            me.currentAjaxRequest.cancelAjaxRequest();
        }

        me.isLoading = true;
        response = window.TL.ApiClient.EventHandlers.getHandlers({
            list_id: me.listId,
            handler_types: "notification"
        });

        me.currentAjaxRequest = response;
        response.then({
            success: function (response) {
                me.isLoading = false;
                if (response.success) {
                    const scheduledEvents = response.data.filter(handler => me.isScheduled ? handler.event === "scheduled" : handler.event !== "scheduled")
                    if (scheduledEvents.length != 0) {
                        scheduledEvents.map(scheduledEvent => {
                            scheduledEvent.data = JSON.parse(scheduledEvent.data)
                        })
                        // console.log(scheduledEvents);
                        me.reminders = [...scheduledEvents];
                    } else {
                        me.reminders = me.getDefaultRemindersData()
                    }
                    me.onRemindersChange()
                } else {
                    Ext.Msg.alert('Error', response.message)
                }
            },
            failure: function (response) {
                me.isLoading = false;
                if (response.statusText == "transaction aborted") {
                    return;
                }
                Ext.Msg.alert('Error', 'Something went wrong. Please try again.')
            }
        });
    }

    updateReminder(reminder) {
        const me = this;
        const listener = { ...reminder };

        me.savingReminders.add(reminder.id || "new_reminder");
        listener.data = JSON.stringify(listener.data);
        window.TL.ApiClient.EventHandlers.addHandler({
            list_id: me.listId,
            event: reminder.event,
            listener: JSON.stringify(listener),
            column_id: reminder.column_id || 0
        }).then({
            success: (response) => {
                if (!response.success) {
                    console.log(response);
                    return;
                }
                me.savingReminders.delete(reminder.id || "new_reminder");

                if (!reminder.id) {
                    me.lastCreatedReminderId = response.data;
                }
                me.isReminderSavedTextShown = true;
                setTimeout(() => {
                    me.isReminderSavedTextShown = false;
                    me.lastCreatedReminderId = null;
                }, 3000);
                if (!reminder.id) {
                    reminder.id = response.data
                } else {
                }
                me.onRemindersChange()
                // console.log(response);
                // this.getEmailColumns(response.data)
            }
        })
    }

    getMailBodyTemplate = () => {
        var me = this,
            list = me.getSheet(),
            columns = TL.list.settings.lookup.CriteriaHelper.formatColumns(Ext.clone(list.columns), {
                listNameStr: list.name,
                listNameSuffix: '',
                aliasKey: 'alias_name',
                doExpandSubSheetColumns: false,
                ignoreDefaultColumns: true
            });

        return TL.list.RowTemplateManager.getRowMailTemplate(list.name, columns);
    }

    setData(data) {
        // if (!this.hotReloadData) { // todo check environment.. do only if it is development.
        //     this.hotReloadData = data; //for hotreload
        // } else {
        //     this.hotReloadData = { ...this.hotReloadData, ...data }
        // }
        Object.keys(data).forEach(key => {
            this[key] = data[key];
        });
        this.fetchData();
    }

    get hasReminders() {
        return this.reminders.find(r => r.id > 0) !== undefined;
    }
}

decorate(RemindersStore, {
    anchorEl: observable,
    isLoading: observable,
    reminders: observable,
    sheetUsers: observable,
    sheetRoles: observable,
    savingReminders: observable,
    isReminderSavedTextShown: observable,

    hasReminders: computed,
    list: computed,
    isAddNewReminderShown: computed,
    sheetColumnsFormatted: computed,
    dateColumns: computed,
    sheetUsersFormatted: computed,
});

export default RemindersStore;